/**
 * Under the framework of Creator Nav Standalone, two React apps are
 * mounted in the DOM. This usually results in the child app having
 * the wrong name and version.
 *
 * This util function returns the same props recieved by server context
 * with the correct name and version
 *
 * @param {object} props props recieved by server context
 * @returns {object} props, with child app name & version merged if present
 */
export const getChildAppProps = (props: any) => {
    const childApp = props?.['child_apps']?.[0] ?? [];
    const [childAppName, childAppVersion] = childApp;

    let finalProps = props;

    if (
        (childAppName && childAppVersion) ||
        (childAppName && !props.app_version)
    ) {
        finalProps = {
            ...props,
            app_name: childAppName,
            app_version: childAppVersion,
        };
    }

    return finalProps;
};
